<template>
  <div class="order-details" ref="container">
    <nav-bar
        fixed
        z-index="99"
        title="订单详情"
        left-text="返回"
        left-arrow
        @click-left="handleBack"
    />
    <div style="height: 46px"></div>
    <div
        class="font-color-red"
        v-if="status == 0 && userCategory == 1 && orderInfo.refundStatus != 1"
    >
      <div style="padding: 0.19rem">{{ orderInfo._status._msg }}</div>
    </div>
    <div
        class="font-color-red"
        v-if="orderInfo.refundStatus == 1 && userCategory == 1"
    >
      <div style="padding: 0.19rem">
        退款申请已成功提交审核，平台审核时效为3个工作日
      </div>
    </div>
    <div
        class="font-color-red"
        v-if="status == 1 && userCategory == 1 && !orderInfo.refundStatus"
    >
      <div style="padding: 0.19rem">
        您的订单支付已完成，目前正在等待教练确认（48小时内），请您耐心等待。
      </div>
    </div>
    <div
        class="font-color-red"
        v-if="status == 2 && userCategory == 2 && !orderInfo.refundStatus"
    >
      <div style="padding: 0.19rem">
        您已确认接单，请尽快联系客户，并根据双方达成一致的预约时间进行教练约谈。
      </div>
    </div>
    <div v-if="orderInfo.cartInfo">
      <div
          class="acea-row row-center row-between-wrapper top-header"
          v-if="userCategory == 2"
      >
        <span class="order-status">{{
            orderInfo.refundStatus === 1
                ? "售后中"
                : orderInfo.refundStatus === 2
                    ? "已退款"
                    : statusText[status]
          }}</span>
        <img
            class="pictrue"
            :src="orderInfo.lcUser && orderInfo.lcUser.avatar"
        />
        <div class="text">
          <div class="name" v-if="orderInfo.lcUser">
            {{ orderInfo.lcUser.nickname || "名字A" }}
          </div>
          <!-- <div class="money line1">
            {{ orderInfo.cartInfo[0].productInfo.storeInfo }}
          </div> -->
        </div>
      </div>
      <div class="acea-row row-center row-between-wrapper top-header" v-else>
        <img class="pictrue" :src="orderInfo.cartInfo[0].productInfo.image" />
        <div class="text">
          <div class="name">
            {{ orderInfo.cartInfo[0].productInfo.storeName || "名字B" }}
          </div>
          <div class="money line1">
            {{ orderInfo.cartInfo[0].productInfo.storeInfo }}
          </div>
        </div>
      </div>
    </div>
    <div class="message-box" v-if="userCategory == 2">
      <div class="message-title">需求描述</div>
      <div class="message-content">{{ form.remark }}</div>
    </div>
    <div class="message-box" v-if="userCategory == 2">
      <div class="message-title">客户资料</div>
      <div class="message-content">
        <div>姓名：{{ lcUser.nickname }}</div>
        <div v-if="lcUser.phone">手机号：{{ lcUser.phone }}</div>
        <div v-if="lcUser.email">邮箱：{{ lcUser.email }}</div>
        <div v-if="lcUser.wechatNumber">微信：{{ lcUser.wechatNumber }}</div>
        <div v-if="form.sexLabel">性别: {{ form.sexLabel }}</div>
        <template v-if="form.childNum">
          <div>家中孩子的数量: {{ form.childNum }}</div>
          <div>孩子的出生日期: {{ form.childBirthday }}</div>
          <div>孩子性别: {{ form.childSexLabel }}</div>
          <div>与孩子的关系: {{ form.childRelationLabel }}</div>
        </template>

        <div v-for="(item, index) in detailFjson" :key="index">
          {{ item.label }}: {{ item.isChecked }}
        </div>
      </div>
    </div>
    <div class="message-box" v-if="userCategory == 1">
      <div class="message-title">教练资料</div>
      <div class="message-content">
        <div>真实姓名：{{ coachInfo.realName }}</div>
        <div>手机号：{{ coachInfo.phone }}</div>
        <div>邮箱：{{ coachInfo.email }}</div>
        <div>微信：{{ coachInfo.wechatNumber }}</div>
      </div>
    </div>

    <div class="message-box">订单号：{{ orderInfo.orderId }}</div>
    <div class="message-box" v-if="orderInfo.reviewType">
      测评类型：{{ orderInfo.reviewType }}
    </div>
    <div class="message-box" v-if="orderInfo.cartInfo && orderInfo.cartInfo.length > 0 && orderInfo.cartInfo[0].productInfo">
      <div class="message-title">套餐信息</div>
      <div class="message-content">
        <div v-if="orderInfo.cartInfo[0].productInfo.attrInfo">
          <div v-if="orderInfo.cartInfo[0].productInfo.attrInfo.skuName">
            套餐名称：{{ orderInfo.cartInfo[0].productInfo.attrInfo.skuName }}
          </div>
          <div v-if="orderInfo.cartInfo[0].productInfo.attrInfo.sku">
            旅程次数：{{ orderInfo.cartInfo[0].productInfo.attrInfo.sku }}{{ isSingle(orderInfo) ? '' : '' }}
          </div>
        </div>
        <div v-else-if="isSingle(orderInfo)">
          单次订单
        </div>
        <div>
          单次价格：￥{{ orderInfo.cost }}
        </div>
      </div>
    </div>
    <div class="message-box">
      <div class="message-title">订单金额</div>
      <div class="message-content">
        <span style="color: #ff7733; font-weight: 700; font-size: 0.4rem"
        >￥{{ orderInfo.payPrice }}</span
        >
        <span style="font-size: 0.24rem; margin-left: 0.4rem"
        >优惠：￥{{ orderInfo.couponPrice }}</span
        >
      </div>
    </div>
    <div
        class="message-box"
        v-if="
        (orderInfo.refundReasonWapExplain || orderInfo.refundReasonWap) &&
        orderInfo.refundStatus
      "
    >
      <div class="message-title">退款原因</div>
      <div class="message-content">
        {{ orderInfo.refundReasonWap }}<br />{{ orderInfo.refundReason }}<br />
      </div>
    </div>
    <!-- <div class="message-box">
      <div class="message-title">付款说明</div>
      <div class="message-content" v-html="orderInfo.payDesc">
      </div>
    </div> -->
    <div style="height: 1.2rem"></div>
    <div class="footer acea-row row-right row-middle">
      <template v-if="status == 0 && !orderInfo.refundStatus">
        <div class="bnt cancel" @click="cancelOrder" v-if="userCategory == 1">
          取消订单
        </div>
        <div class="bnt bg-color-theme" @click="toPay" v-if="userCategory == 1">
          立即付款
        </div>
      </template>
      <template v-if="status == 1 && !orderInfo.refundStatus">
        <div
            v-if="userCategory == 2 && orderInfo.auditStatus === 1"
            class="bnt btn-disabled"
            @click.stop="showAuditPendingMessage()"
        >
          来源审核中
        </div>
        <div
            v-else-if="userCategory == 2"
            class="bnt bg-color-theme"
            @click="submitOrder"
        >
          确认接单
        </div>
        <div
            v-if="userCategory == 1 && !hidenCencelBtn"
            class="bnt bg-color-theme"
            @click="
            $router.push({
              path: '/order/refund/' + orderInfo.orderId,
              query: { firstOrder: orderInfo.firstOrder, userCategory },
            })
          "
        >
          提前终止订单
        </div>
        <div
            v-if="userCategory == 2 && status != 1"
            class="bnt bg-color-theme"
            @click="cellOrder"
        >
          提前终止订单
        </div>
      </template>
      <template v-if="status == 7 && !orderInfo.refundStatus">
        <div
            class="bnt bg-color-theme"
            @click="finishOrder"
            v-if="userCategory == 1"
        >
          <!-- {{ orderInfo.firstOrder == 1 ? "确认旅程继续" : "确认继续旅程" }} -->
          <!-- 首约和单次 -->
          <span v-if="orderInfo.firstOrder == 1 || isSingle(orderInfo)"
          >订单确认完成</span
          >
          <span v-else>确认继续旅程</span>
        </div>
        <div
            v-if="userCategory == 1 && !hidenCencelBtn"
            class="bnt bg-color-theme"
            @click="
            $router.push({
              path: '/order/refund/' + orderInfo.orderId,
              query: { firstOrder: orderInfo.firstOrder, userCategory },
            })
          "
        >
          提前终止订单
        </div>
      </template>
      <template v-if="status === 2 && !orderInfo.refundStatus">
        <div
            class="bnt bg-color-theme"
            @click="coachOrder"
            v-if="userCategory == 2"
        >
          <!-- {{ orderInfo.firstOrder == 1 ? "教练确认完成" : "确认继续旅程" }} -->
          <!-- 首约和单次 -->
          <span v-if="orderInfo.firstOrder == 1 || isSingle(orderInfo)"
          >订单确认完成</span
          >
          <span v-else>确认继续旅程</span>
        </div>
        <div
            v-if="userCategory == 1 && !hidenCencelBtn"
            class="bnt bg-color-theme"
            @click="
            $router.push({
              path: '/order/refund/' + orderInfo.orderId,
              query: { firstOrder: orderInfo.firstOrder, userCategory },
            })
          "
        >
          提前终止订单
        </div>
        <div
            v-if="userCategory == 2"
            class="bnt bg-color-theme"
            @click="cellOrder"
        >
          提前终止订单
        </div>
      </template>
      <template v-if="status == 3 && !orderInfo.refundStatus">
        <div
            class="bnt bg-color-theme"
            v-if="userCategory == 1"
            @click="showDialog = true"
        >
          续约
        </div>
        <div
            v-if="userCategory == 1"
            class="bnt bg-color-theme"
            @click="goToEvaluate()"
        >
          去评价
        </div>
      </template>
      <template v-if="(status == 4 || status == 5) && !orderInfo.refundStatus">
        <div
            class="bnt bg-color-theme"
            v-if="userCategory == 1"
            @click="showDialog = true"
        >
          续约
        </div>
        <div
            class="bnt bg-color-theme"
            v-if="orderInfo.productReplyList.length"
            @click="
            $router.push({
              path: '/order/order_evaluate/' + id,
              query: { userCategory },
            })
          "
        >
          查看评价
        </div>
      </template>
      <template v-if="orderInfo.refundStatus">
        <div>
          {{ orderInfo._status._title }}
        </div>
      </template>
      <!-- <template v-if="status == 4">
        <div class="bnt cancel" @click="delOrder">
          删除订单
        </div>
      </template> -->
    </div>
    <Popup v-model="showDialog" round>
      <div class="agree-title">{{ articleInfo.title }}</div>
      <div class="agree-content">
        <div v-html="articleInfo.content"></div>
      </div>
      <div class="agree-btn" @click="toXuyue()">确认</div>
    </Popup>
    <Popup v-model="showDialog1" round>
      <div class="agree-title">{{ articleInfo1.title }}</div>
      <div class="agree-content">
        <div v-html="articleInfo1.content"></div>
      </div>
      <div class="agree-btn" @click="submitOrder()">确认</div>
    </Popup>

    <!-- 新增来源选择对话框 -->
    <van-dialog v-model="showSourceDialog" title="请选择订单来源" :show-confirm-button="false" :show-cancel-button="true" close-on-click-overlay class="source-select-dialog">
      <div class="source-select-container">
        <div class="source-select-header"></div>
        <div class="domain-tabs">
          <div
              class="domain-tab"
              :class="{ active: selectedDomain === 'private' }"
              @click="switchDomain('private')"
          >
            私域
          </div>
          <div
              class="domain-tab"
              :class="{ active: selectedDomain === 'public' }"
              @click="switchDomain('public')"
          >
            公域
          </div>
        </div>

        <div class="source-options">
          <div
              v-for="option in sourceOptions"
              :key="option.id"
              class="source-option"
              :class="{
              selected: selectedSources.some(s => s.id === option.id),
              disabled: hasOtherSelected && option.value !== '3'
            }"
              @click="toggleSource(option)"
          >
            <div class="source-checkbox">
              <div class="checkbox-inner" v-if="selectedSources.some(s => s.id === option.id)"></div>
            </div>
            <div class="source-label">{{ option.label }}</div>
          </div>

          <!-- 备注输入框 - 仅当"其他"选项被选中时显示 -->
          <div class="remark-input" v-if="hasOtherSelected">
            <input
                type="text"
                v-model="sourceRemark"
                placeholder="请输入其他来源内容"
                @blur="validateRemark"
            />
          </div>
          <!--
          <div class="source-note">
            {{ orderSourceDescription || "说明: " + (selectedDomain === 'private' ?
            '私域来源为线下转介绍与教练和其本人直接接触而来的客户' :
            '公域来源为平台引流或平台推广获得的客户') }}
          </div>
          -->
          <div class="instruction-content" v-html="orderSourceDescription"></div>
        </div>

        <div class="confirm-button" @click="confirmSourceSelection">
          确认来源
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { orderDetail } from "@api/order";
import { getViewDetails } from "@api/public";
import { dataFormat } from "@utils";
import { mapGetters } from "vuex";
import { getDict } from "@api/admin";
import {
  cancelOrderHandle,
  takeOrderHandle,
  delOrderHandle,
  payOrderHandle,
} from "@libs/order";
import {
  submitOrderHandle,
  finishOrderHandle,
  coachOrderHandle,
  postOrderRefund,
  coachConfirmSource,
  inviteEvaluation,
} from "@api/order";
import { NavBar, Popup, Dialog } from "vant";
import request from "@utils/request";

const NAME = "OrderDetails";

export default {
  name: NAME,
  components: { NavBar, Popup, VanDialog: Dialog.Component },
  props: {},
  data: function () {
    return {
      orderTypeName: "普通订单",
      orderTypeNameStatus: true,
      id: this.$route.params.id,
      orderInfo: {
        _status: {},
      },
      status: 9,
      mapKay: "",
      form: {},
      detailFjson: [],
      coachInfo: {},
      lcUser: {},
      statusText: {
        0: "待支付",
        1: "待确认",
        2: "进行中",
        3: "待评价",
        4: "旅程已",
        5: "已取消",
        6: "售后",
        7: "待客户确认旅程",
      },
      hidenCencelBtn: false,
      articleInfo: {},
      showDialog: false,
      showDialog1: false,
      articleInfo1: {},
      // 当前用户是已什么身份查看当前页面信息的,默认为用户
      userCategory: this.$route.query.userCategory || 1,
      // 新增 - 来源选择相关数据
      selectedDomain: 'public',
      selectedSources: [],
      sourceOptions: [],
      showSourceDialog: false,
      sourceRemark: "",
      hasOtherSelected: false,
      orderSourceDescription: "",
      // 新增 - 标记是否来自评价页面
      isFromEvaluate: false,
      isSubmitting: false, // 防抖标志
    };
  },
  computed: {
    refundOrder() {
      return this.orderInfo.refund_status > 0;
    },
    ...mapGetters(["userInfo"]),
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.getDetail();
      }
    },
  },
  inject: ["app"],
  created() {
    this.$route.query &&
    this.$route.query.from &&
    this.$route.query.from == "order" &&
    (this.hidenCencelBtn = true);

    // 检查是否来自评价页面
    this.isFromEvaluate = this.$route.query.from === 'evaluate';
  },
  mounted: function () {
    this.getDetail();
    this.getAgree();
    this.getSystemConfig(); // 新增：获取订单来源说明
  },
  methods: {
    dataFormat,
    // 新增：将UI/订单数据中的来源值映射到API所需的来源值
    // UI/订单数据 selectedSource: 1 = 私域, 2 = 公域
    // 后端 API confirmOrderSource: 1 = 私域, 2 = 公域
    mapUiSourceToApiSource(uiSource) {
      if (uiSource === 1) {
        // UI 选择 1 (私域)
        return 1; // API 值 1 (私域)
      }
      if (uiSource === 2) {
        // UI 选择 2 (公域)
        return 2; // API 值 2 (公域)
      }
      return null;
    },
    getAgree: function () {
      getViewDetails(48).then((res) => {
        this.articleInfo = res.data;
      });
      getViewDetails(51).then((res) => {
        this.articleInfo1 = res.data;
      });
    },
    toXuyue() {
      this.$router.push({
        path: `/order/submit/${this.orderInfo.cartInfo[0].productInfo.id}`,
        query: { type: 1 },
      });
    },
    getDict: function (name, cal) {
      getDict({ name }).then((res) => {
        cal(res);
      });
    },
    goBack() {
      const history = this.app.history,
          last = history[history.length - 1] || {};
      if (last.name === "MyOrder") return this.$router.go(-1);
      else return this.$router.replace({ path: "/order/list/" });
    },
    cancelOrder() {
          cancelOrderHandle(this.orderInfo.orderId)
              .then(() => {
                setTimeout(() => this.goBack(), 300);//延迟返回
              })
              .catch((err) => {
                this.$toast.fail(err.msg || "取消订单失败");
                this.getDetail();//刷新
              });
    },
    takeOrder() {
      takeOrderHandle(this.orderInfo.orderId).finally(() => {
        this.getDetail();
      });
    },
    delOrder() {
      // 使用项目自定义的Dialog参数格式
      this.$dialog.confirm({
        mes: "确定要删除此订单吗？删除后将无法恢复",
        opts: () => {
          delOrderHandle(this.orderInfo.orderId).then(() => {
            this.$toast.success('删除成功');
            setTimeout(() => this.goBack(), 300);
          }).catch(err => {
            this.$toast.fail(err.msg || '删除失败');
          });
        }
      });
    },
    // 判断当前订单是否为单次订单
    isSingle(order) {
      // 判断是否有购物车信息
      if (
          order.cartInfo &&
          Array.isArray(order.cartInfo) &&
          order.cartInfo.length > 0
      ) {
        const cartInfo = order.cartInfo[0];
        if (cartInfo.productAttrUnique == "") return true;
        if (!cartInfo.productInfo.attrInfo) return false;
        return cartInfo.productInfo.attrInfo.sku == 1;
      }
      return false;
    },

    getDetail() {
      const id = this.id;
      if (!id) {
        this.$toast.fail("订单不存在");
        return;
      }
      orderDetail(id, { userCategory: this.userCategory })
          .then((res) => {
            this.orderInfo = res.data;
            this.status = res.data.status;
            this.form = res.data.reservationInfoVo || {};
            this.lcUser = res.data.lcUser;
            this.coachInfo = res.data.coailUser;
            if (this.userCategory == 1) return;
            res.data.reservationInfoVo &&
            this.getDict("sex_code", (result) => {
              this.form.sexLabel = result.data.find(
                  (item) => item.value == res.data.reservationInfoVo.sex
              ).label;
              res.data.reservationInfoVo.childSex != null &&
              (this.form.childSexLabel = result.data.find(
                  (item) => item.value == res.data.reservationInfoVo.childSex
              ).label);
            });
            this.form.childRelation &&
            this.getDict("child_relation", (result) => {
              this.form.childRelationLabel = result.data.find(
                  (item) => item.value == res.data.reservationInfoVo.childRelation
              ).label;
            });
            const detailFjsons = this.form.detailFjson
                ? res.data.reservationInfoVo.detailFjson.split(",")
                : [];
            this.getDict("yu_sq", (result) => {
              this.detailFjson = result.data.map((item) => ({
                label: item.label,
                isChecked: detailFjsons.includes(item.value) ? "是" : "否",
              }));
            });
          })
          .catch((err) => {
            this.$toast.fail(err.msg || "获取订单详情失败");
          });
    },
    async toPay() {
      var that = this;
      await payOrderHandle(this.orderInfo.orderId, "weixin", that.from);
      that.getDetail();
    },
    submitOrder() {
      if (this.isSubmitting) return;

      this.showDialog1 = false;

      // 如果是公益订单(welfareOrder=1)，则直接确认订单，不需要确认来源
      if (this.orderInfo.welfareOrder === 1) {
        this.isSubmitting = true;
        this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
        submitOrderHandle({ uni: this.orderInfo.orderId })
            .then(() => {
              this.$toast.success("订单已确认");
              this.getDetail();
            })
            .catch(err => {
              this.$toast.fail(err.msg || "订单确认失败");
            })
            .finally(() => {
              this.isSubmitting = false;
            });
        return;
      }

      // 如果是首单(firstOrder=1)，则直接确认订单，不需要确认来源
      if (this.orderInfo.firstOrder === 1) {
        this.isSubmitting = true;
        this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
        submitOrderHandle({ uni: this.orderInfo.orderId })
            .then(() => {
              this.$toast.success("订单已确认");
              this.getDetail();
            })
            .catch(err => {
              this.$toast.fail(err.msg || "订单确认失败");
            })
            .finally(() => {
              this.isSubmitting = false;
            });
        return;
      }

      // ---- 订单审核状态检查 ----
      if (this.orderInfo.auditStatus === 1) {
        this.$toast.info("您选择的订单来源正在审核中，请耐心等待。");
        return;
      }

      if (this.orderInfo.auditStatus === 2) {
        // 审核已通过，直接使用 order.confirmOrderSource
        if (this.orderInfo.confirmOrderSource === 1 || this.orderInfo.confirmOrderSource === 2) {
          this.$dialog.confirm({
            mes: "订单来源已由管理员审核通过，是否直接确认订单？",
            opts: () => {
              if (this.isSubmitting) return;
              this.isSubmitting = true;
              this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
              submitOrderHandle({
                uni: this.orderInfo.orderId,
                confirmOrderSource: this.orderInfo.confirmOrderSource
              })
                  .then(() => {
                    this.$toast.success("订单已确认");
                    this.getDetail();
                  })
                  .catch(err => {
                    this.$toast.fail(err.msg || "订单确认失败");
                  })
                  .finally(() => {
                    this.isSubmitting = false;
                  });
            }
          });
        } else {
          this.$toast.fail("审核已通过，但订单来源信息不明确，请联系技术支持。");
        }
        return;
      }

      // ---- 已有confirmOrderSource的处理 ----
      if (this.orderInfo.confirmOrderSource === 1 || this.orderInfo.confirmOrderSource === 2) {
        const apiConfirmedSource = this.orderInfo.confirmOrderSource;

        this.$dialog.confirm({
          mes: "订单来源已指定，是否直接确认订单？",
          opts: () => {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
            submitOrderHandle({
              uni: this.orderInfo.orderId,
              confirmOrderSource: apiConfirmedSource
            })
                .then(() => {
                  this.$toast.success("订单已确认");
                  this.getDetail();
                })
                .catch(err => {
                  this.$toast.fail(err.msg || "订单确认失败");
                })
                .finally(() => {
                  this.isSubmitting = false;
                });
          }
        });
        return;
      }

      // ---- 显示来源选择对话框 ----
      this.selectedSources = [];
      this.hasOtherSelected = false;
      this.sourceRemark = "";

      // 根据订单的source字段设置默认的域类型
      // source: 1 = 私域, 2 = 公域
      this.selectedDomain = this.orderInfo.source === 1 ? 'private' : 'public';

      this.showSourceDialog = true;

      // 加载对应域类型的来源选项
      this.loadSourceOptions(this.selectedDomain);
    },

    // 加载来源选项
    loadSourceOptions(domain) {
      const dictName = domain === 'private'
          ? 'order_source_description_coach'
          : 'order_source_description_platform';

      // 使用正确封装的getDict方法获取字典数据
      getDict({ name: dictName }).then(res => {
        if (res.status === 200 && res.data) {
          this.sourceOptions = res.data || [];
        } else {
          this.sourceOptions = [];
          this.$toast.fail('获取来源选项失败');
        }
      }).catch(err => {
        console.error('获取来源选项错误:', err);
        this.sourceOptions = [];
        this.$toast.fail('获取来源选项失败');
      });
    },

    // 切换公域/私域标签
    switchDomain(domain) {
      this.selectedDomain = domain;
      this.selectedSources = []; // 清除已选择的来源
      this.hasOtherSelected = false; // 重置"其他"选项状态
      this.sourceRemark = ""; // 清空备注
      this.loadSourceOptions(domain);
    },

    // 选择来源
    toggleSource(source) {
      // 如果选项已禁用，则不处理
      if (this.hasOtherSelected && source.value !== '3') {
        return;
      }

      // 判断是否已选择该选项
      const isSelected = this.selectedSources.some(item => item.id === source.id);

      // 如果是"其他"选项
      if (source.value === '3') {
        if (isSelected) {
          // 取消选择"其他"选项
          this.selectedSources = this.selectedSources.filter(item => item.id !== source.id);
          this.hasOtherSelected = false;
          this.sourceRemark = ""; // 清空备注
        } else {
          // 选择"其他"选项，清除其他所有选择
          this.selectedSources = [source];
          this.hasOtherSelected = true;
        }
      } else {
        // 普通选项
        if (isSelected) {
          // 取消选择
          this.selectedSources = this.selectedSources.filter(item => item.id !== source.id);
        } else {
          // 添加选择
          this.selectedSources.push(source);
        }
      }
    },

    // 验证备注信息
    validateRemark() {
      if (this.hasOtherSelected && !this.sourceRemark.trim()) {
        this.$toast.fail("请输入其他来源内容");
        return false;
      }
      return true;
    },

    // 确认来源选择
    confirmSourceSelection() {
      if (this.selectedSources.length === 0) {
        this.$toast.fail("请选择订单来源");
        return;
      }

      // 如果选择了"其他"且未填写备注，则验证失败
      if (this.hasOtherSelected && !this.validateRemark()) {
        return;
      }

      const orderToProcess = this.orderInfo;
      const selectedDomain = this.selectedDomain;
      const selectedSources = this.selectedSources;

      // 获取所有选中选项的label，用逗号拼接
      let sourceLabels = selectedSources.map(item => item.label).join(',');

      // 如果有用户手动输入的备注（当选择"其他"时），加上这个备注
      const userRemark = this.sourceRemark.trim();
      if (this.hasOtherSelected && userRemark) {
        sourceLabels = sourceLabels + ":" + userRemark;
      }

      this.showSourceDialog = false; // 关闭对话框

      // 检查是否需要审核
      const needsReview = selectedDomain !== (orderToProcess.source === 1 ? 'private' : 'public');
      const apiSourceType = selectedDomain === 'private' ? 1 : 2;

      if (needsReview) {
        // 使用项目自定义的Dialog参数格式
        this.$dialog.confirm({
          mes: "是否确认订单？",
          opts: () => {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
            // 先提交来源确认
            coachConfirmSource({
              uni: orderToProcess.orderId,
              confirmOrderSource: apiSourceType,
              sourceRemark: sourceLabels
            })
                .then(() => {
                  // 然后直接提交订单确认
                  return submitOrderHandle({
                    uni: orderToProcess.orderId,
                    confirmOrderSource: apiSourceType,
                    sourceRemark: sourceLabels
                  });
                })
                .then(() => {
                  this.$toast.success("订单已确认！");
                  // 提交成功后清空备注
                  this.sourceRemark = "";
                  this.getDetail();
                })
                .catch(err => {
                  this.$toast.fail(err.msg || "操作失败");
                })
                .finally(() => {
                  this.isSubmitting = false;
                });
          }
        });
      } else {
        // 不需要审核的情况，直接调用confirmOrder方法
        this.confirmOrder(orderToProcess, apiSourceType, null, sourceLabels);
      }
    },

    confirmOrder(order, apiSourceType, sourceIds, sourceLabels) {
      // 使用项目自定义的Dialog参数格式
      this.$dialog.confirm({
        mes: "是否确认订单？",
        opts: () => {
          if (this.isSubmitting) return;
          this.isSubmitting = true;
          this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
          coachConfirmSource({
            uni: order.orderId,
            confirmOrderSource: apiSourceType,
            sourceRemark: sourceLabels
          }).then(() => {
            return submitOrderHandle({
              uni: order.orderId,
              confirmOrderSource: apiSourceType,
              sourceRemark: sourceLabels
            });
          }).then(() => {
            // 提交成功后清空备注
            this.sourceRemark = "";
            this.getDetail();
          }).catch(err => {
            this.$toast.fail(err.msg || "操作失败");
          }).finally(() => {
            this.isSubmitting = false;
          });
        }
      });
    },

    // 获取系统配置
    getSystemConfig: function() {
      // 使用项目中已配置的request模块发送请求
      request.get("/api/lcSystemConfig", {
        size: 1000
      }).then(data => {
        console.log("系统配置数据:", data);
        // API返回的结构是 {data: {content: [...]} }
        if (data && data.data && data.data.content) {
          // 查找id为293的配置项
          const config = data.data.content.find(item => item.id === 293);
          if (config) {
            console.log("找到订单来源说明配置:", config);
            this.orderSourceDescription = config.value;
          } else {
            console.log("未找到id为293的配置项");
            // 设置默认的订单来源说明
            this.orderSourceDescription = "请选择订单来源，公域来源为平台引流或平台推广获得的客户，私域来源为线下转介绍与教练和其本人直接接触而来的客户。";
          }
        }
      }).catch(error => {
        console.error('获取系统配置失败', error);
        // 发生错误时使用默认订单来源说明
        this.orderSourceDescription = "请选择订单来源，公域来源为平台引流或平台推广获得的客户，私域来源为线下转介绍与教练和其本人直接接触而来的客户。";
      });
    },

    finishOrder() {
      let message =
          this.orderInfo.firstOrder == 1
              ? "请您确认：已经与教练完成了本次对话。"
              : "您已与教练完成3次约谈，确认后将会继续教练旅程，不再退款。";

      // 如果是公益教练
      if (this.orderInfo.welfareOrder == 1) {
        message = "您已与教练完成3次约谈，确认后将会继续教练旅程，不再退款。";
      }

      //  如果为单次订单 或者 单次并且为续约
      if (this.isSingle(this.orderInfo)) {
        message = "请您确认：已经与教练完成了本次对话。";
      }

      // 使用项目自定义的Dialog参数格式
      this.$dialog.confirm({
        mes: message,
        opts: () => {
          finishOrderHandle({ uni: this.orderInfo.orderId }).then((res) => {
            this.getDetail();
          }).catch(err => {
            this.$toast.fail(err.msg || "操作失败");
          });
        }
      });
    },
    coachOrder() {
      let message =
          this.orderInfo.firstOrder == 1
              ? "请您确认：已经与客户完成了教练对话。"
              : "请您确认：您已经与客户达成一致，继续整个教练服务旅程(教练3次后确认)。";

      // 如果是公益教练
      if (this.orderInfo.welfareOrder == 1) {
        message =
            "请您确认：您已经与客户达成一致，继续整个教练服务旅程(教练3次后确认)。";
      }

      //  如果为单次订单
      if (this.isSingle(this.orderInfo)) {
        message = "请您确认：已经与客户完成了教练对话。";
      }

      // 使用项目自定义的Dialog参数格式
      this.$dialog.confirm({
        mes: message,
        opts: () => {
          coachOrderHandle({ uni: this.orderInfo.orderId }).then((res) => {
            this.getDetail();
          }).catch(err => {
            this.$toast.fail(err.msg || "操作失败");
          });
        }
      });
    },
    cellOrder() {
      // 使用项目自定义的Dialog参数格式
      this.$dialog.confirm({
        mes: "订单一旦终止，系统会默认发起退费申请。是否确认提前终止？",
        opts: () => {
          postOrderRefund({
            uni: this.orderInfo.orderId,
            text: "教练结束旅程并退款",
            userCategory: 2,
          })
              .then((res) => {
                this.$toast.success(res.msg);
                this.getDetail();
              })
              .catch((e) => {
                this.$toast.fail(e.msg || "操作失败");
              });
        }
      });
    },
    showAuditPendingMessage() {
      this.$toast.info("该订单来源正在审核中，请耐心等待。");
    },
    // 添加去评价方法，携带参数
    goToEvaluate() {
      // 准备需要传递的参数
      const params = new URLSearchParams();

      // 订单基本信息
      params.append('orderId', this.orderInfo.orderId);

      // 套餐信息
      if (this.orderInfo.cartInfo && this.orderInfo.cartInfo[0] && this.orderInfo.cartInfo[0].productInfo) {
        const productInfo = this.orderInfo.cartInfo[0].productInfo;
        params.append('storeName', productInfo.storeName || '');

        if (productInfo.attrInfo) {
          params.append('skuName', productInfo.attrInfo.skuName || '');
          params.append('sku', productInfo.attrInfo.sku || '');
          params.append('price', productInfo.attrInfo.price || '');
        }
        if (productInfo.attrInfo == null) {//如果是单次套餐attrInfo是==null的
          params.append('skuName', '单次套餐');
          params.append('sku', '1');
          params.append('price', productInfo.price || '');
        }
      }

      // 教练信息
      if (this.orderInfo.coailUser) {
        params.append('coachName', this.orderInfo.coailUser.realName || '');
        params.append('coachPhone', this.orderInfo.coailUser.phone || '');
        params.append('coachUid', this.orderInfo.coailUser.uid || '');
      }

      // 用户信息
      if (this.orderInfo.lcUser) {
        params.append('userUid', this.orderInfo.lcUser.uid || '');
        params.append('userName', this.orderInfo.lcUser.realName || '');
        params.append('userPhone', this.orderInfo.lcUser.phone || '');
      }

      // 构建评价链接
      const evalLink = `/goods_evaluate/${this.orderInfo.cartInfo[0].unique}?${params.toString()}`;

      // 跳转到评价页面
      this.$router.push(evalLink);
    },
    // 新增：处理返回按钮点击
    handleBack() {
      // 如果是从评价页面来的，则返回首页
      if (this.isFromEvaluate) {
        this.$router.push('/');
      } else {
        // 否则保持原来的返回逻辑
        this.$router.push({
          path: '/order/list',
          query: {
            userCategory: this.userCategory,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.order-details {
  overflow: hidden;

  .header {
    height: 0.84rem;
    line-height: 0.84rem;
    padding: 0 0.3rem;
    background-color: #0ce6df;
    color: #ffffff;
    text-align: center;
  }

  .top-header {
    padding: 0.26rem;
    background: #ffffff;
    position: relative;

    .pictrue {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 50%;
      margin-right: 0.23rem;
    }

    .text {
      flex: 1;
      color: #666666;
    }

    .name {
      font-size: 0.26rem;
    }

    .money {
      width: 5.1rem;
      margin-top: 0.2rem;
    }
  }

  .message-box {
    padding: 0.26rem;
    background: #ffffff;
    margin-top: 0.19rem;

    .message-title {
      font-size: 0.26rem;
      font-weight: 600;
    }

    .message-content {
      margin-top: 0.23rem;
      color: #999999;
      line-height: 0.6rem;
    }
  }

  .order-status {
    position: absolute;
    color: #ff5500;
    right: 0.1rem;
    top: 0.6rem;
    width: 2rem;
    text-align: center;
    transform: rotateZ(45deg) scale(1);
    font-size: 0.26rem;
    padding: 0.1rem 0;
    border-bottom: 1px solid #ff5500;
    border-top: 1px solid #ff5500;
  }
}

.agree-content {
  width: 80vw;
  min-height: 20vh;
  max-height: 60vh;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0.3rem;
}

.agree-title {
  padding: 0.3rem;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
}

.agree-btn {
  display: block;
  color: #fff;
  height: 0.68rem;
  background: #0ce6df;
  line-height: 0.68rem;
  text-align: center;
  border-radius: 0.5rem;
  margin: 0.3rem;
}

/* 新增：禁用按钮的样式 */
.btn-disabled {
  background-color: #ccc !important;
  color: #666 !important;
  cursor: not-allowed;
}

/* 来源选择对话框样式 */
.source-select-container {
  padding: 15px;
  position: relative;
}

.source-select-header {
  text-align: center;
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: bold;
}

.domain-tabs {
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
  border: 1px solid #eee;
}

.domain-tab {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  background-color: #f8f8f8;
  color: #333;
  font-size: 14px;
  cursor: pointer;
}

.domain-tab.active {
  background-color: #0ce6df;
  color: white;
}

.source-options {
  margin-bottom: 20px;
}

.source-option {
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  transition: all 0.3s;
}

.source-option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.source-checkbox {
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.source-option.selected .source-checkbox {
  border-color: #0ce6df;
  background-color: #0ce6df;
}

.checkbox-inner {
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-top: -2px;
}

.source-label {
  font-size: 14px;
  color: #333;
}

.source-note {
  padding: 10px 0;
  line-height: 1.4;
  font-size: 12px;
  color: #999;
}

.remark-input {
  margin: 15px 0;
}

.remark-input input {
  width: 100%;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  font-size: 14px;
}

.confirm-button {
  width: 100%;
  background-color: #0ce6df;
  color: white;
  text-align: center;
  padding: 12px 0;
  border-radius: 25px;
  font-size: 16px;
  margin-top: 15px;
  cursor: pointer;
}

/* 修改van-dialog样式 */
:deep(.van-dialog) {
  border-radius: 12px;
  overflow: hidden;
  width: 90% !important;
  max-width: 320px;
}

:deep(.van-dialog__header) {
  padding-top: 20px;
  font-weight: bold;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.close-icon i {
  font-size: 16px;
  color: #666;
}
</style>
